import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";
import useDrawer from "../contexts/Drawer";
import logohorizontal from "../assets/logohorizontal.png";
import formatName from "../helpers/formatName";
import { useAppSelector } from "../store";
import HeaderMenu from "./Menu/HeaderMenu";

function UserAvatar({ name }: { name?: string }) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexFlow: "row nowrap",
        alignItems: "center",
        gap: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
      })}
    >
      {name ? (
        <Avatar
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          {name.trim()[0]}
        </Avatar>
      ) : (
        <Avatar />
      )}

      <Typography>
        Olá{!!name && `, ${formatName(name.trim().split(/\s+/i)[0])}`}!
      </Typography>
    </Box>
  );
}

export const Header = () => {
  const { isLargeScreen, isOpen, setIsOpen } = useDrawer();

  const { cliente } = useAppSelector((state) => state.cliente);

  return (
    <AppBar
      sx={(theme) => ({
        background: theme.palette.common.white,
        color: "inherit",
        position: "fixed",
      })}
    >
      <Toolbar sx={{ position: "relative" }} disableGutters>
        {!isLargeScreen && (
          <IconButton
            color="primary"
            onClick={() => setIsOpen(!isOpen)}
            sx={(theme) => ({
              height: "100%",
              padding: theme.spacing(2),
              position: "absolute",
              top: 0,
              left: 0,
            })}
          >
            {isOpen ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        )}

        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",

            [theme.breakpoints.up("lg")]: {
              justifyContent: "space-between",
              maxWidth: theme.breakpoints.values.xl,
              margin: "0 auto",
              padding: theme.spacing(0, 4),
            },
          })}
        >
          <img src={logohorizontal} alt="Fynd" />

          {isLargeScreen && (
            <Box
              sx={(theme) => ({
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: theme.spacing(4),
                height: "100%",
                color: "inherit",
              })}
            >
              <HeaderMenu />
              <UserAvatar name={cliente?.nome} />
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
